import { render, staticRenderFns } from "./AssignBranchesModal.vue?vue&type=template&id=4495fbca&"
import script from "./AssignBranchesModal.vue?vue&type=script&lang=js&"
export * from "./AssignBranchesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4495fbca')) {
      api.createRecord('4495fbca', component.options)
    } else {
      api.reload('4495fbca', component.options)
    }
    module.hot.accept("./AssignBranchesModal.vue?vue&type=template&id=4495fbca&", function () {
      api.rerender('4495fbca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/organization/services/AssignBranchesModal.vue"
export default component.exports